/* global Helpers, $, StatisticsPositions */

window['statistics#show'] = function () {
  Helpers.initCollapsableTable()

  $('#client_types').on('change', function () {
    const typesSelect = $(this)
    const clientsSelect = $('#client_company_ids')
    const collection = clientsSelect.find('option')
    const typeValue = typesSelect.val()

    collection.each(function () {
      $(this).removeClass('hidden')
      if (typeValue && !$(this).data('type').match(typeValue)) { $(this).addClass('hidden') }
    })
  }).trigger('change')

  // Toggle statistics
  $('.statistics_visible').on('change', function (e) {
    const value = e.target.value
    const checked = e.target.checked
    const unselected = $('#disabled_statistics').val()
    let array = unselected ? unselected.split(' ') : []
    const url = $(this).closest('form').attr('action')
    const index = array.indexOf(value)
    index === -1 ? array.push(value) : array = _.without(array, value)

    $(`.statistics-block#${value}`).fadeToggle(checked)
    $('#disabled_statistics').val(array.join(' '))
    $.ajax({
      type: 'PUT',
      url,
      data: { 'user[disabled_statistics]': array },
      dataType: 'json'
    })
  })

  // Toggle all statistics
  $('#statistics_toggle_all').on('click', function () {
    const unselected = $('#disabled_statistics').val()
    let array = unselected ? unselected.split(' ') : []
    const url = $(this).closest('form').attr('action')

    if ($('.statistics_visible:checked').length < $('.statistics_visible').length) {
      // Turn on
      $('.statistics_visible:not(:checked)').each(function (i, el) {
        $(el).prop('checked', true)
        array = _.without(array, $(el).val())
      })
      $('.statistics-block').fadeIn()
    } else {
      // Turn off
      $('.statistics_visible').each(function (i, el) {
        $(el).prop('checked', false)
        array.push($(el).val())
      })
      $('.statistics-block').fadeOut()
    }

    array = (array && array.length) ? array : ['-1']
    $('#disabled_statistics').val(array.join(' '))
    $.ajax({
      type: 'PUT',
      url,
      data: { 'user[disabled_statistics]': array },
      dataType: 'json'
    })
  })

  // Toggle chart/table view
  $('#view-toggler input').on('change', function (e) {
    $(this).closest('form').submit()
  })

  StatisticsPositions.init()
}
